export const REPORT_ISSUE_DEPARTMENT = 'Technical Support';

export const REPORT_ISSUE_SUBJECT = 'Communicator bug report';

export const REPORT_ISSUE_CONNECTIVITY_SUBJECT =
  'Communicator connectivity issue';

export const REPORT_ISSUE_MODAL_TITLE = 'Submit a new Broadvoice ticket';

export const REPORT_ISSUE_MODAL_TESTID = 'reportIssueModal';

export const REPORT_ISSUE_ERROR_TITLE = 'Error loading';

export const REPORT_ISSUE_ERROR_MESSAGE =
  "Right now we couldn't load the Report an Issue form.";

// Max wait for the preflight reachability check before treating it as a failure.
export const REPORT_ISSUE_REACHABILITY_TIMEOUT_MS = 6_000;
